export const messageType = {
  44: "/adAccount/RechargeHistory", // 广告账户管理>充值记录-充值记录页
  52: "/adAccount/RechargeHistory", // "广告账户管理>充值记录-充值进度页"
  53: "/adAccount/RechargeHistory", // "广告账户管理>充值记录-充值进度页"
  45: "/adAccount/RechargeHistory", // "广告账户管理>充值记录-充值进度页" 失败
  41: "/adAccount/mediaTransferFunds", // "广告账户管理>转款记录-转款进度页"
  49: "/adAccount/mediaTransferFunds", // "广告账户管理>转款记录-转款记录页"
  47: "/adAccount/mediaTransferFunds", // "广告账户管理>转款记录-转款记录页"
  48: "/adAccount/mediaTransferFunds", // "广告账户管理>转款记录-转款进度页"
  43: "/adAccount/zeroClearingHistory", // "广告账户管理>清要记录-清零记录页"
  46: "/adAccount/zeroClearingHistory", // "广告账户管理>清要记录--清雲进度页"
  51: "/adAccount/zeroClearingHistory", // "广告账户管理>清要记录-清要进度页"
  50: "/adAccount/zeroClearingHistory", // "广告账户管理>清要记录-清要记录页"
  42: "/adAccount/list", // "广告账户管理>清要记录--清雲进度页"
};
export const query = {
  44: "rechargeRecord",
  53: "rechargeRecord",
  52: "rechargeRecord",
  45: "rechargeRecord",
  41: "transferProgress",
  49: "transferRecord",
  47: "transferRecord",
  48: "transferProgress",
  43: "clearingRecord",
  46: "clearingProgress",
  51: "clearingProgress",
  50: "clearingProgress",
};
